// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Button } from '@/components/ui/button';
// import { Card } from '@/components/ui/card';
// import { Input } from '@/components/ui/input';
// import { toast } from 'sonner';
// import { Plus, FileText, Search } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const Invoices = () => {
//   const [invoices, setInvoices] = useState([]);
//   const [businesses, setBusinesses] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filters, setFilters] = useState({
//     business_id: '',
//     customer_id: '',
//     status: '',
//   });
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     fetchInvoices();
//   }, [filters]);

//   const fetchData = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const [businessesRes, customersRes] = await Promise.all([
//         axios.get(`${API}/businesses`, {
//           headers: { Authorization: `Bearer ${token}` },
//         }),
//         axios.get(`${API}/customers`, {
//           headers: { Authorization: `Bearer ${token}` },
//         }),
//       ]);
//       setBusinesses(businessesRes.data);
//       setCustomers(customersRes.data);
//     } catch (error) {
//       toast.error('Failed to fetch data');
//     }
//   };

//   const fetchInvoices = async () => {
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const params = new URLSearchParams();
//       if (filters.business_id) params.append('business_id', filters.business_id);
//       if (filters.customer_id) params.append('customer_id', filters.customer_id);
//       if (filters.status) params.append('status', filters.status);

//       const response = await axios.get(`${API}/invoices?${params.toString()}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setInvoices(response.data);
//     } catch (error) {
//       toast.error('Failed to fetch invoices');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getStatusBadge = (status) => {
//     const styles = {
//       paid: 'bg-emerald-100 text-emerald-700 border-emerald-200',
//       unpaid: 'bg-amber-100 text-amber-700 border-amber-200',
//       overdue: 'bg-red-100 text-red-700 border-red-200',
//     };
//     return (
//       <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide border ${styles[status]}`}>
//         {status}
//       </span>
//     );
//   };

//   const getCustomerName = (customerId) => {
//     const customer = customers.find(c => c.id === customerId);
//     return customer ? customer.name : 'Unknown';
//   };

//   const getBusinessName = (businessId) => {
//     const business = businesses.find(b => b.id === businessId);
//     return business ? business.name : 'Unknown';
//   };

//   return (
//     <div className="p-8 md:p-12" data-testid="invoices-page">
//       <div className="flex items-center justify-between mb-12">
//         <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Invoices</h1>
//         <Button
//           className="gap-2"
//           onClick={() => navigate('/invoices/new')}
//           data-testid="create-invoice-button"
//         >
//           <Plus className="w-4 h-4" />
//           Create Invoice
//         </Button>
//       </div>

//       {/* Filters */}
//       <Card className="p-6 mb-8 border-border/50">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           <div>
//             <label className="text-sm font-medium mb-2 block">Business</label>
//             <select
//               className="w-full px-3 py-2 border border-input rounded-md bg-white"
//               value={filters.business_id}
//               onChange={(e) => setFilters({ ...filters, business_id: e.target.value })}
//               data-testid="filter-business"
//             >
//               <option value="">All Businesses</option>
//               {businesses.map((business) => (
//                 <option key={business.id} value={business.id}>{business.name}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="text-sm font-medium mb-2 block">Customer</label>
//             <select
//               className="w-full px-3 py-2 border border-input rounded-md bg-white"
//               value={filters.customer_id}
//               onChange={(e) => setFilters({ ...filters, customer_id: e.target.value })}
//               data-testid="filter-customer"
//             >
//               <option value="">All Customers</option>
//               {customers.map((customer) => (
//                 <option key={customer.id} value={customer.id}>{customer.name}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="text-sm font-medium mb-2 block">Status</label>
//             <select
//               className="w-full px-3 py-2 border border-input rounded-md bg-white"
//               value={filters.status}
//               onChange={(e) => setFilters({ ...filters, status: e.target.value })}
//               data-testid="filter-status"
//             >
//               <option value="">All Statuses</option>
//               <option value="paid">Paid</option>
//               <option value="unpaid">Unpaid</option>
//               <option value="overdue">Overdue</option>
//             </select>
//           </div>
//         </div>
//       </Card>

//       {loading ? (
//         <div className="text-muted-foreground">Loading...</div>
//       ) : invoices.length === 0 ? (
//         <Card className="p-12 text-center border-dashed">
//           <FileText className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
//           <p className="text-lg text-muted-foreground mb-4">No invoices found</p>
//           <Button onClick={() => navigate('/invoices/new')} data-testid="create-first-invoice">
//             Create Your First Invoice
//           </Button>
//         </Card>
//       ) : (
//         <div className="space-y-4">
//           {invoices.map((invoice) => (
//             <Card
//               key={invoice.id}
//               className="p-6 hover:shadow-hover transition-all cursor-pointer border-border/50"
//               onClick={() => navigate(`/invoices/${invoice.id}`)}
//               data-testid={`invoice-card-${invoice.id}`}
//             >
//               <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-center">
//                 <div>
//                   <p className="text-sm text-muted-foreground mb-1">Invoice #</p>
//                   <p className="font-bold text-lg">{invoice.invoice_number}</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-muted-foreground mb-1">Customer</p>
//                   <p className="font-medium">{getCustomerName(invoice.customer_id)}</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-muted-foreground mb-1">Business</p>
//                   <p className="font-medium">{getBusinessName(invoice.business_id)}</p>
//                 </div>
//                 <div>
//                   <p className="text-sm text-muted-foreground mb-1">Amount</p>
//                   <p className="text-2xl font-bold text-primary" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
//                     ${invoice.total.toFixed(2)}
//                   </p>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <p className="text-sm text-muted-foreground mb-1">Status</p>
//                     {getStatusBadge(invoice.status)}
//                   </div>
//                 </div>
//               </div>
//               <div className="mt-4 pt-4 border-t border-border flex items-center justify-between text-sm text-muted-foreground">
//                 <span>Date: {invoice.invoice_date}</span>
//                 <span>Due: {invoice.due_date}</span>
//               </div>
//             </Card>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Invoices;
// import React, { useState, useEffect } from 'react';
// // import axios from 'axios';
// import { Button } from '@/components/ui/button';
// import { Card } from '@/components/ui/card';
// import { Input } from '@/components/ui/input';
// import { toast } from 'sonner';
// import { Plus, FileText, Search } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// // ⬇️ NEW: Firebase imports
// import { db, auth } from '../firebase';
// import {
//   collection,
//   getDocs,
//   query,
//   where,
// } from 'firebase/firestore';

// // const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const Invoices = () => {
//   const [invoices, setInvoices] = useState([]);
//   const [businesses, setBusinesses] = useState([]);
//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filters, setFilters] = useState({
//     business_id: '',
//     customer_id: '',
//     status: '',
//   });
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     fetchInvoices();
//   }, [filters]);

//   const fetchData = async () => {
//     try {
//       const user = auth.currentUser;
//       if (!user) {
//         setBusinesses([]);
//         setCustomers([]);
//         return;
//       }

//       // Old axios version:
//       // const token = localStorage.getItem('token');
//       // const [businessesRes, customersRes] = await Promise.all([
//       //   axios.get(`${API}/businesses`, { headers: { Authorization: `Bearer ${token}` } }),
//       //   axios.get(`${API}/customers`, { headers: { Authorization: `Bearer ${token}` } }),
//       // ]);
//   const bizSnap = await getDocs(collection(db, 'businesses'));
//     const custSnap = await getDocs(collection(db, 'customers'));

//       setBusinesses(bizSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
//       setCustomers(custSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to fetch data');
//     }
//   };

//   const fetchInvoices = async () => {
//     try {
//       setLoading(true);
//       const user = auth.currentUser;
//       if (!user) {
//         setInvoices([]);
//         setLoading(false);
//         return;
//       }

//       // Old axios version:
//       // const token = localStorage.getItem('token');
//       // const params = new URLSearchParams();
//       // if (filters.business_id) params.append('business_id', filters.business_id);
//       // if (filters.customer_id) params.append('customer_id', filters.customer_id);
//       // if (filters.status) params.append('status', filters.status);
//       // const response = await axios.get(`${API}/invoices?${params.toString()}`, {
//       //   headers: { Authorization: `Bearer ${token}` },
//       // });
//       // setInvoices(response.data);

//       // 🔹 Fetch all invoices for this user, then filter in JS
//       const q = query(
//         //uid kuFTC3sUg7QAZBU3978pIPjpp9M2
//         collection(db, 'invoices'),
//         // where('userId', '==', user.uid)
//       );
//       const snap = await getDocs(q);
//       let list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

//       if (filters.business_id) {
//         list = list.filter((inv) => inv.business_id === filters.business_id);
//       }
//       if (filters.customer_id) {
//         list = list.filter((inv) => inv.customer_id === filters.customer_id);
//       }
//       if (filters.status) {
//         list = list.filter((inv) => inv.status === filters.status);
//       }

//       setInvoices(list);
//     } catch (error) {
//       console.error(error);
//       toast.error('Failed to fetch invoices');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getStatusBadge = (status) => {
//     const styles = {
//       paid: 'bg-emerald-100 text-emerald-700 border-emerald-200',
//       unpaid: 'bg-amber-100 text-amber-700 border-amber-200',
//       overdue: 'bg-red-100 text-red-700 border-red-200',
//     };
//     return (
//       <span
//         className={`px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide border ${
//           styles[status] || ''
//         }`}
//       >
//         {status}
//       </span>
//     );
//   };

//   const getCustomerName = (customerId) => {
//     const customer = customers.find((c) => c.id === customerId);
//     return customer ? customer.name : 'Unknown';
//   };

//   const getBusinessName = (businessId) => {
//     const business = businesses.find((b) => b.id === businessId);
//     return business ? business.name : 'Unknown';
//   };

//   return (
//     <div className="p-8 md:p-12" data-testid="invoices-page">
//       <div className="flex items-center justify-between mb-12">
//         <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Invoices</h1>
//         <Button
//           className="gap-2"
//           onClick={() => navigate('/invoices/new')}
//           data-testid="create-invoice-button"
//         >
//           <Plus className="w-4 h-4" />
//           Create Invoice
//         </Button>
//       </div>

//       {/* Filters */}
//       <Card className="p-6 mb-8 border-border/50">
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//           <div>
//             <label className="text-sm font-medium mb-2 block">Business</label>
//             <select
//               className="w-full px-3 py-2 border border-input rounded-md bg-white"
//               value={filters.business_id}
//               onChange={(e) =>
//                 setFilters({ ...filters, business_id: e.target.value })
//               }
//               data-testid="filter-business"
//             >
//               <option value="">All Businesses</option>
//               {businesses.map((business) => (
//                 <option key={business.id} value={business.id}>
//                   {business.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="text-sm font-medium mb-2 block">Customer</label>
//             <select
//               className="w-full px-3 py-2 border border-input rounded-md bg-white"
//               value={filters.customer_id}
//               onChange={(e) =>
//                 setFilters({ ...filters, customer_id: e.target.value })
//               }
//               data-testid="filter-customer"
//             >
//               <option value="">All Customers</option>
//               {customers.map((customer) => (
//                 <option key={customer.id} value={customer.id}>
//                   {customer.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <label className="text-sm font-medium mb-2 block">Status</label>
//             <select
//               className="w-full px-3 py-2 border border-input rounded-md bg-white"
//               value={filters.status}
//               onChange={(e) =>
//                 setFilters({ ...filters, status: e.target.value })
//               }
//               data-testid="filter-status"
//             >
//               <option value="">All Statuses</option>
//               <option value="paid">Paid</option>
//               <option value="unpaid">Unpaid</option>
//               <option value="overdue">Overdue</option>
//             </select>
//           </div>
//         </div>
//       </Card>

//       {loading ? (
//         <div className="text-muted-foreground">Loading...</div>
//       ) : invoices.length === 0 ? (
//         <Card className="p-12 text-center border-dashed">
//           <FileText className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
//           <p className="text-lg text-muted-foreground mb-4">No invoices found</p>
//           <Button
//             onClick={() => navigate('/invoices/new')}
//             data-testid="create-first-invoice"
//           >
//             Create Your First Invoice
//           </Button>
//         </Card>
//       ) : (
//         <div className="space-y-4">
//           {invoices.map((invoice) => {
//             const total = Number(invoice.total ?? 0).toFixed(2);

//             return (
//               <Card
//                 key={invoice.id}
//                 className="p-6 hover:shadow-hover transition-all cursor-pointer border-border/50"
//                 onClick={() => navigate(`/invoices/${invoice.id}`)}
//                 data-testid={`invoice-card-${invoice.id}`}
//               >
//                 <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-center">
//                   <div>
//                     <p className="text-sm text-muted-foreground mb-1">Invoice #</p>
//                     <p className="font-bold text-lg">{invoice.invoice_number}</p>
//                   </div>
//                   <div>
//                     <p className="text-sm text-muted-foreground mb-1">Customer</p>
//                     <p className="font-medium">
//                       {getCustomerName(invoice.customer_id)}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-sm text-muted-foreground mb-1">Business</p>
//                     <p className="font-medium">
//                       {getBusinessName(invoice.business_id)}
//                     </p>
//                   </div>
//                   <div>
//                     <p className="text-sm text-muted-foreground mb-1">Amount</p>
//                     <p
//                       className="text-2xl font-bold text-primary"
//                       style={{ fontFamily: 'JetBrains Mono, monospace' }}
//                     >
//                       ${total}
//                     </p>
//                   </div>
//                   <div className="flex items-center justify-between">
//                     <div>
//                       <p className="text-sm text-muted-foreground mb-1">Status</p>
//                       {getStatusBadge(invoice.status)}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="mt-4 pt-4 border-t border-border flex items-center justify-between text-sm text-muted-foreground">
//                   <span>Date: {invoice.invoice_date}</span>
//                   <span>Due: {invoice.due_date}</span>
//                 </div>
//               </Card>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Invoices;
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import {
  Plus,
  FileText,
  MoreVertical,
  Edit,
  Trash2,
  Ban,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '@/lib/utils';

// shadcn dropdown
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';

// Firebase
import { db, auth } from '../firebase';
import {
  collection,
  getDocs,
  query,
  doc,
  deleteDoc,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';

const Invoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    business_id: '',
    customer_id: '',
    status: '',
    template_type: '',
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchInvoices();
  }, [filters]);

  /* ---------------------------------- */
  /* Fetch Businesses + Customers */
  /* ---------------------------------- */
  const fetchData = async () => {
    try {
      const user = auth.currentUser;
      if (!user) return;

      const bizSnap = await getDocs(collection(db, 'businesses'));
      const custSnap = await getDocs(collection(db, 'customers'));

      setBusinesses(bizSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setCustomers(custSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch data');
    }
  };

  /* ---------------------------------- */
  /* Fetch Invoices */
  /* ---------------------------------- */
  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) return;

      const q = query(collection(db, 'invoices'));
      const snap = await getDocs(q);

      let list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

      if (filters.business_id) {
        list = list.filter((i) => i.business_id === filters.business_id);
      }
      if (filters.customer_id) {
        list = list.filter((i) => i.customer_id === filters.customer_id);
      }
      if (filters.status) {
        list = list.filter((i) => i.status === filters.status);
      }
      if (filters.template_type) {
        list = list.filter((i) => (i.template_type || 'gst') === filters.template_type);
      }

      list.sort((a, b) => new Date(b.invoice_date || 0) - new Date(a.invoice_date || 0));

      setInvoices(list);
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch invoices');
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------------------- */
  /* Actions */
  /* ---------------------------------- */
  const handleEdit = (id) => {
    navigate(`/invoices/${id}/edit`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this invoice permanently?')) return;
    try {
      await deleteDoc(doc(db, 'invoices', id));
      toast.success('Invoice deleted');
      fetchInvoices();
    } catch (err) {
      console.error(err);
      toast.error('Delete failed');
    }
  };

  const handleCancel = async (id) => {
    try {
      await updateDoc(doc(db, 'invoices', id), {
        status: 'cancelled',
        updatedAt: serverTimestamp(),
      });
      toast.success('Invoice cancelled');
      fetchInvoices();
    } catch (err) {
      console.error(err);
      toast.error('Cancel failed');
    }
  };
const currencySymbolMap = {
  USD: '$',
  INR: '₹',
  CAD: 'C$',
  AUD: 'A$',
  EUR: '€',
  GBP: '£',
};
const getInvoiceCurrencySymbol = (invoice) => {
  const customer = customers.find(
    (c) => c.id === invoice.customer_id
  );

  const currency = customer?.currency || 'USD';
  return currencySymbolMap[currency] || currency;
};
  /* ---------------------------------- */
  /* Helpers */
  /* ---------------------------------- */
  const getStatusBadge = (status) => {
    const styles = {
      paid: 'bg-emerald-100 text-emerald-700 border-emerald-200',
      unpaid: 'bg-amber-100 text-amber-700 border-amber-200',
      overdue: 'bg-red-100 text-red-700 border-red-200',
      cancelled: 'bg-gray-200 text-gray-600 border-gray-300',
      proforma: 'bg-blue-100 text-blue-700 border-blue-200',
    };

    return (
      <span
        className={`px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase border ${
          styles[status] || ''
        }`}
      >
        {status}
      </span>
    );
  };

  const getBusinessName = (id) =>
    businesses.find((b) => b.id === id)?.name || 'Unknown';

  const getCustomerName = (id) =>
    customers.find((c) => c.id === id)?.name || 'Unknown';

  /* ---------------------------------- */
  /* UI */
  /* ---------------------------------- */
  const totalReceived = invoices
    .filter((inv) => inv.status === 'paid')
    .reduce((sum, inv) => sum + Number(inv.total || 0), 0);

  const totalDue = invoices
    .filter((inv) => inv.status === 'unpaid' || inv.status === 'overdue')
    .reduce((sum, inv) => sum + Number(inv.total || 0), 0);

  const displayCurrency = invoices.length > 0 ? getInvoiceCurrencySymbol(invoices[0]) : '';

  return (
    <div className="p-8 md:p-12">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-4xl font-bold">Invoices</h1>
        <div className="flex gap-3">
          <Button variant="outline" onClick={() => navigate('/invoices/new?type=non-gst')}>
            <Plus className="w-4 h-4 mr-2" />
            Create Non-GST
          </Button>
          <Button onClick={() => navigate('/invoices/new?type=gst')}>
            <Plus className="w-4 h-4 mr-2" />
            Create GST
          </Button>
        </div>
      </div>

      {/* Filters */}
      <Card className="p-6 mb-8 border-border/50">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="text-sm font-medium mb-2 block">Business</label>
            <select
              className="w-full px-3 py-2 border border-input rounded-md bg-background"
              value={filters.business_id}
              onChange={(e) => setFilters({ ...filters, business_id: e.target.value })}
            >
              <option value="">All Businesses</option>
              {businesses.map((b) => (
                <option key={b.id} value={b.id}>{b.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-sm font-medium mb-2 block">Customer</label>
            <select
              className="w-full px-3 py-2 border border-input rounded-md bg-background"
              value={filters.customer_id}
              onChange={(e) => setFilters({ ...filters, customer_id: e.target.value })}
            >
              <option value="">All Customers</option>
              {customers.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-sm font-medium mb-2 block">Status</label>
            <select
              className="w-full px-3 py-2 border border-input rounded-md bg-background"
              value={filters.status}
              onChange={(e) => setFilters({ ...filters, status: e.target.value })}
            >
              <option value="">All Statuses</option>
              <option value="paid">Paid</option>
              <option value="unpaid">Unpaid</option>
              <option value="overdue">Overdue</option>
              <option value="proforma">Proforma</option>
            </select>
          </div>
          <div>
            <label className="text-sm font-medium mb-2 block">Template</label>
            <select
              className="w-full px-3 py-2 border border-input rounded-md bg-background"
              value={filters.template_type}
              onChange={(e) => setFilters({ ...filters, template_type: e.target.value })}
            >
              <option value="">All Templates</option>
              <option value="gst">Standard (GST)</option>
              <option value="non-gst">Non-GST (No Tax)</option>
            </select>
          </div>
        </div>
      </Card>

      {loading ? (
        <div>Loading...</div>
      ) : invoices.length === 0 ? (
        <Card className="p-12 text-center border-dashed">
          <FileText className="w-14 h-14 mx-auto mb-4 text-muted-foreground" />
          <p>No invoices found</p>
        </Card>
      ) : (
        <div className="space-y-4">
          {invoices.map((inv) => (
            <Card
              key={inv.id}
              className="p-6 hover:shadow transition cursor-pointer"
              onClick={() =>
                inv.status !== 'cancelled' &&
                navigate(`/invoices/${inv.id}`)
              }
            >
              <div className="grid grid-cols-1 md:grid-cols-6 gap-4 items-center">
                <div>
                  <p className="text-sm text-muted-foreground">Invoice #</p>
                  <p className="font-bold">{inv.invoice_number}</p>
                </div>

                <div>
                  <p className="text-sm text-muted-foreground">Customer</p>
                  <p>{getCustomerName(inv.customer_id)}</p>
                </div>

                <div>
                  <p className="text-sm text-muted-foreground">Business</p>
                  <p>{getBusinessName(inv.business_id)}</p>
                </div>

                <div>
                  <p className="text-sm text-muted-foreground">Amount</p>
                  <p className="font-bold text-primary">
  {getInvoiceCurrencySymbol(inv)}{' '}
  {Number(inv.total || 0).toFixed(2)}
</p>
                </div>

                <div>{getStatusBadge(inv.status)}</div>

                {/* MORE MENU */}
                <div
                  className="flex justify-end"
                  onClick={(e) => e.stopPropagation()}
                >
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" size="icon">
                        <MoreVertical className="w-4 h-4" />
                      </Button>
                    </DropdownMenuTrigger>

                    <DropdownMenuContent align="end">
                      <DropdownMenuItem onClick={() => handleEdit(inv.id)}>
                        <Edit className="w-4 h-4 mr-2" /> Edit
                      </DropdownMenuItem>

                      {inv.status !== 'cancelled' && (
                        <DropdownMenuItem
                          onClick={() => handleCancel(inv.id)}
                        >
                          <Ban className="w-4 h-4 mr-2" /> Cancel
                        </DropdownMenuItem>
                      )}

                      <DropdownMenuItem
                        className="text-destructive"
                        onClick={() => handleDelete(inv.id)}
                      >
                        <Trash2 className="w-4 h-4 mr-2" /> Delete
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-border flex items-center justify-between text-sm text-muted-foreground">
                <span>Date: {formatDate(inv.invoice_date)}</span>
                <span>Due: {formatDate(inv.due_date)}</span>
              </div>
            </Card>
          ))}
          
          <Card className="p-6 mt-8 border-t-4 border-t-primary shadow-sm bg-background">
            <div className="flex flex-col md:flex-row justify-between items-center text-lg font-bold">
              <span>Totals (Filtered):</span>
              <div className="flex gap-8 mt-4 md:mt-0">
                <div className="text-emerald-600 flex flex-col items-center">
                  <span className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-1">Received</span>
                  <span>{displayCurrency}{totalReceived.toFixed(2)}</span>
                </div>
                <div className="text-amber-600 flex flex-col items-center">
                  <span className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-1">Due</span>
                  <span>{displayCurrency}{totalDue.toFixed(2)}</span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
};

export default Invoices;
